import { HttpInterceptorFn, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../guards/service/auth.service';
import { Observable } from 'rxjs';

const isCommunityPublicUrl = (url: string) =>
  /\/api\/(registration|login|send-otp|reset-password)/i.test(url) ||
  /\/api\/user$/i.test(url) ||
  /\/api\/careers/i.test(url) ||
  /\/api\/communities\/[^\/]+$/i.test(url) ||
  /\/api\/public\//i.test(url);

function resolveSpaceId(auth: AuthService): string {
  const pending = sessionStorage.getItem('pendingSpaceID') || '';
  if (pending && pending !== '0') return pending;
  const ls = localStorage.getItem('spaceID') || '';
  if (ls && ls !== '0') return ls;
  const sid = auth.getSpaceIdFromToken?.();
  return sid ? String(sid) : '';
}

export const HeaderInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const auth = inject(AuthService);

  let headers = request.headers
    .set('code', 'ed97b5d600d2e7cc855c755b44f55537')
    .set('version', '1.0.0')
    .set('platform', 'web');

  const spaceID = resolveSpaceId(auth);
  if (spaceID) headers = headers.set('spaceid', spaceID).set('spaceID', spaceID);

  const communityId = localStorage.getItem('communityId') || sessionStorage.getItem('pendingCommunityId') || '';
  if (communityId) headers = headers.set('communityid', communityId);

  const slug = localStorage.getItem('slug') || sessionStorage.getItem('pendingSlug') || '';
  if (slug) headers = headers.set('slug', slug);

  if (!isCommunityPublicUrl(request.url)) {
    const token = auth.getJwtToken?.();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
  }

  // helpful for tracing
  headers = headers.set('x-request-id', `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,8)}`);

  return next(request.clone({ headers }));
};
